<template>
    <section class="l-section l-section--main o-cartMobileWeek">
        <div
            class="l-container l-container--main"
            v-if="customer && currentAddress"
        >
            <div class="l-container o-cartMobileWeek__header">
                <div class="l-row l-row--touch o-cartMobileWeek__columns">
                    <div
                        v-if="customerAddresses[0] && customerAddresses[0].street && customerAddresses[0].city"
                        class="l-row__column o-cartMobileWeek__column"
                    >
                        <p class="a-label o-cartMobileWeek__label">Adres dostawy</p>
                        <p class="a-tabs__address">{{ currentAddress.street }} {{ currentAddress.number }}</p>
                        <p class="a-tabs__address">{{ currentAddress.postcode }} {{ currentAddress.city }}</p>
                    </div>
                    <div class="l-row__column o-cartMobileWeek__column">
                        <p class="a-label o-cartMobileWeek__label">Wartość zamówienia</p>
                        <p
                            v-if="!isNaN(weekAmount)"
                            class="a-tabs__price a-price a-price--small o-cartMobileWeek__price"
                        >
                            <span class="a-price__price">{{ weekAmount.toFixed(2).toPLN() }} </span>
                            <span class="a-tabs__priceTime a-price__time">/ 7 dni</span>
                        </p>
                        <p
                            v-if="!isNaN(monthAmount)"
                            class="a-tabs__price a-price a-price--small o-cartMobileWeek__price"
                        >{{ monthAmount.toFixed(2).toPLN() }} <span class="a-tabs__priceTime a-price__time">/ 1 mc</span></p>
                    </div>
                </div>
            </div>
            <div class="l-row">
                <div class="l-row__column l-row__column--10">
                    <offer-week />
                </div>
                <!-- <div class="l-row__column">
                    <featured-products />
                </div> -->
            </div>
            <products-modal />
            <div class="a-mobile__buttons">
                <a-button
                    class="a-button--fullwidth"
                    @click="$router.push({ name: 'offer-cart-mobile-summary', params: { slug: $route.params.slug } })"
                >
                    Podsumowanie
                </a-button>
                <button
                    class="m-summary__button a-button a-button--primary"
                    @click="handleSubmit"
                    :disabled="totalAmountValue === 0"
                >
                    Przejdź dalej
                    <svg class="a-button__icon" width="6" height="8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.625 7l3.328-2.958-3.328-2.959" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </button>
            </div>
        </div>
    </section>
</template>

<script>
import OfferWeek from '@/components/offer/OfferWeek'
import ProductsModal from '@/components/ProductsModal'
// import FeaturedProducts from '@/components/FeaturedProducts'

export default {
    components: {
        OfferWeek,
        ProductsModal
        // FeaturedProducts
    },
    metaInfo: {
        title: 'Koszyk'
    },
    computed: {
        currentAddress() {
            return this.$store.getters.customerAddress(this.currentAddressId)
        },
        currentAddressId() {
            return this.$store.getters.currentAddressId
        },
        customer() {
            return this.$store.getters.customer
        },
        totalAmountValue() {
            return this.$store.getters.totalAmount
        },
        customerAddresses() {
            return this.$store.getters.customerAddresses
        },
        weekAmount() {
            return this.$store.getters.offerAmountWeek(this.currentAddressId)
        },
        monthAmount() {
            return this.$store.getters.offerAmountMonth(this.currentAddressId)
        },
        currentWarehouseId() {
            const warehouse = this.$store.getters.customerAddressField(this.currentAddressId, 'warehouse')
            if(typeof warehouse === 'object') {
                return Object.prototype.hasOwnProperty.call(warehouse, 'id') ? warehouse.id : false
            } else {
                return false
            }
        },
        currentCompanySize() {
            return this.$store.getters.customerAddressField(this.currentAddressId, 'companySize')
        }
    },
    watch: {
        currentAddressId() {
            this.$store.dispatch('fetchPricelists').then(() => {
                this.$store.dispatch('fetchPackages', this.currentWarehouseId)
                this.$store.dispatch('fetchFeaturedPackages', {
                    warehouseId: this.currentWarehouseId,
                    companySize: this.currentCompanySize
                })
            })
        }
    },
    methods: {
        handleResize() {
            // on touch redirect to nested route
            if(window.innerWidth > 1024) {
                this.$router.push({ name: 'offer-cart', params: { slug: this.$route.params.slug } })
            }
        },
        handleSubmit() {
            if(this.customerAddresses[this.currentAddressId].clientDetailId !== null) {
                this.$router.push({ name: 'offer-checkout', params: { slug: this.$route.params.slug } })
            } else {
                this.$router.push({ name: 'offer-delivery-address', params: { slug: this.$route.params.slug } })
            }
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
        // get app state
        if(this.$route.params.slug && this.$route.params.slug.length > 0) {
            this.$store.dispatch('fetchOffer', this.$route.params.slug)
        } else {
            this.$store.dispatch('addNotification', {
                type: 'danger',
                content: 'Brak poprawnego ifentyfikatora oferty.',
                limit: 0
            })
            this.$router.push({ name: 'delivery-address' })
        }
        // this.$store.dispatch('fetchPricelists').then(() => {
        //     if(typeof this.currentWarehouseId === 'number') {
        //         this.$store.dispatch('fetchPackageCategories', this.currentWarehouseId)
        //         this.$store.dispatch('fetchPackages', this.currentWarehouseId)
        //         this.$store.dispatch('fetchFeaturedPackages', {
        //             warehouseId: this.currentWarehouseId,
        //             companySize: this.currentCompanySize
        //         })
        //         this.$store.dispatch('fetchDiscountCategories')
        //         this.$store.dispatch('fetchDiscounts')
        //         this.$store.dispatch('fetchSettings')
        //     }
        // })
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>
